import { PermissionsList } from '@modules/permissions/constants';
import { Permission } from '@modules/permissions/utils';

export const TRANSLATION_PLAYER_BONUS_CREATE = Symbol('players-bonus.create');
export const ADMIN_PLAYERS_BONUSES_CREATE_ROUTE_NAME = Symbol('admin.players.bonuses.create');

export const PLAYER_BONUS_CREATE_PERMISSIONS = {
  PLAYER_BONUS_CREATE: new Permission(
    PermissionsList.admin.BONUSES_CREATE,
  ),
};
